const cache = {}

export function useCache(key, fetch) {
  if (cache[key]) {
    return Promise.resolve(cache[key])
  }
  
  return fetch().then(res => {
    cache[key] = res
    return res
  })
}